module.exports = __webpack_public_path__ + "static/hkRep-b5e27b9ab6096c9f320b0a0f89dc5c45.jpg";